function isDyProductRecommendationsEnabled () {

	return window.lp?.globals?.isDyProductRecommendationsEnabled ?? false;

}

export default isDyProductRecommendationsEnabled;
